<template>
  <div>
    <v-container v-if="!is_management">
      <v-row>
        <v-progress-linear
          class="mb-8"
          color="primary"
          indeterminate
          v-if="loading"
        ></v-progress-linear>

        <v-col cols="12">
          <v-simple-table class="d-none d-lg-block">
            <thead class="primary">
              <th class="text-center white--text text-caption font-weight-bold">
                Data entrega
              </th>
              <th class="text-center white--text text-caption font-weight-bold">
                Data devolução
              </th>
              <th class="text-center white--text text-caption font-weight-bold">
                EPI
              </th>
              <th class="text-center white--text text-caption font-weight-bold">
                Risco
              </th>
              <th class="text-center white--text text-caption font-weight-bold">
                Obra
              </th>
              <th class="text-center white--text text-caption font-weight-bold">
                Sharepoint
              </th>
              <th
                class="text-center white--text text-caption font-weight-bold"
                style="width: 10%"
              >
                Opções
              </th>
            </thead>

            <tbody>
              <tr v-for="(item, index) in lines" :key="item._key || index">
                <td class="text-center">
                  {{ formatDate(item.data_entrega) }}
                </td>
                <td class="text-center">
                  {{ formatDate(item.data_devolucao) }}
                </td>
                <td class="text-center">
                  {{ item.epi_desc || "—" }}
                </td>
                <td class="text-center">
                  {{
                    item.risco_ref
                      ? item.risco_ref + " - " + (item.risco_desc || "")
                      : item.risco_desc || "—"
                  }}
                </td>
                <td class="text-center">
                  {{
                    item.obra_codigo
                      ? item.obra_codigo + " - " + (item.obra_descricao || "")
                      : "—"
                  }}
                </td>
                <td class="text-center">
                  <a
                    v-if="item.sharepoint"
                    :href="item.sharepoint"
                    target="_blank"
                    rel="noopener"
                  >
                    Abrir
                  </a>
                  <span v-else>—</span>
                </td>
                <td class="text-center">
                  <v-row align="center" justify="center">
                    <v-col cols="12" md="2">
                      <v-tooltip bottom v-if="item.data_devolucao == null">
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            icon
                            x-small
                            class="error"
                            v-bind="attrs"
                            v-on="on"
                            @click="openExit(item, index)"
                          >
                            <v-icon color="white">mdi-exit-run</v-icon>
                          </v-btn>
                        </template>
                        <span>Registar devolução</span>
                      </v-tooltip>
                    </v-col>
                    <v-col cols="12" md="2">
                      <IconView @click="openEPI(item)" />
                    </v-col>
                  </v-row>
                </td>
              </tr>
            </tbody>
          </v-simple-table>
        </v-col>

        <v-col cols="12" align="center" justify="center">
          <v-btn fab @click="openCreate" class="primary">
            <v-icon>mdi-plus</v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-container>

    <v-dialog
      v-model="dialog"
      :fullscreen="$vuetify.breakpoint.mdAndDown"
      :width="$vuetify.breakpoint.mdAndDown ? '100%' : '75%'"
      content-class="no-scroll-dialog"
    >
      <v-card
        class="elevation-0 ma-0 pa-0 eva-dialog-card"
        :class="{ 'eva-dialog-card--fullscreen': $vuetify.breakpoint.mdAndDown }"
      >
        <v-toolbar dark color="primary" class="eva-dialog-toolbar">
          <v-toolbar-title>
            {{
              viewMode
                ? "Ver EPI"
                : editMode
                ? "Registar devolução"
                : "Adicionar EPI"
            }}
          </v-toolbar-title>

          <v-spacer />

          <v-toolbar-items>
            <v-btn dark text @click="dialog = false"> X </v-btn>
          </v-toolbar-items>
        </v-toolbar>

        <v-divider />

        <div class="eva-dialog-tabs">
          <v-tabs v-model="step" fixed-tabs class="eva-tabs">
            <v-tab>Passo 1 - Detalhes</v-tab>
            <v-tab v-if="!editMode" :disabled="!viewMode && !canGoStep2">
              Passo 2 - Assinatura
            </v-tab>
          </v-tabs>
        </div>

        <div class="eva-dialog-body">
          <v-card-text class="mt-4">
            <v-tabs-items v-model="step" :touchless="true">
              <v-tab-item>
                <v-row class="mt-3">
                  <v-col cols="12" md="4" v-if="is_management">
                    <v-autocomplete
                      label="Utilizador"
                      v-model="fields.user_id"
                      :items="users_list"
                      :item-text="item => item.Codigo + ' - ' + item.Nome"
                      item-value="Codigo"
                      dense 
                      outlined
                      clearable 
                    />
                  </v-col>

                  <v-col cols="12" md="3">
                    <v-text-field
                      ref="dateInput"
                      v-model="fields.data_entrega"
                      type="date"
                      id="birthday"
                      label="Data de entrega"
                      dense
                      outlined
                      :max="maxDate"
                      @click="openNativeDatePicker"
                      @focus="openNativeDatePicker"
                      @mousedown.prevent="openNativeDatePicker"
                    />
                  </v-col>

                  <v-col cols="12" md="5">
                    <v-autocomplete
                      :items="is_management ? obras_user : obras"
                      item-value="Id"
                      label="Obra"
                      :item-text="item => item.Codigo + ' - ' + item.Descricao"
                      dense
                      outlined
                      v-model="fields.obra"
                      :loading="is_management && loadingObras"
                    />
                  </v-col>
 
                  <v-col cols="12">
                    <v-card elevation="0">
                      <v-card-title class="warning white--text">
                        Equipamentos
                      </v-card-title>
                      <v-card-text class="mt-2">
                        <v-row
                          v-for="(eq, i) in fields.equipments"
                          :key="eq._key || i"
                          class="mb-2"
                        >
                          <v-col cols="12" md="2">
                            <v-autocomplete
                              label="Categoria"
                              v-model="eq.category_key"
                              :items="categoryOptions"
                              item-text="label"
                              item-value="value"
                              :disabled="isEquipmentReadOnly(eq)"
                              dense
                              outlined
                              @change="onCategoryChange(eq)"
                            />
                          </v-col>

                          <v-col cols="12" md="3">
                            <v-autocomplete
                              label="Equipamento"
                              v-model="eq.epi_id"
                              item-value="id"
                              item-text="description"
                              :items="getFilteredEpis(eq)"
                              :disabled="isEquipmentReadOnly(eq)"
                              dense
                              outlined
                              clearable
                              @change="onEquipmentChange(eq)"
                            />
                          </v-col>

                          <v-col cols="12" md="1">
                            <v-text-field
                              label="Qtd"
                              type="number"
                              v-model="eq.qty"
                              :disabled="isEquipmentReadOnly(eq)"
                              dense
                              outlined
                            />
                          </v-col>

                          <v-col cols="12" md="3">
                            <v-autocomplete
                              label="Riscos"
                              v-model="eq.riscos"
                              :items="risks"
                              :item-text="item => item.reference + ' - ' + item.description"
                              item-value="id"
                              multiple
                              chips
                              deletable-chips
                              clearable
                              :disabled="isEquipmentReadOnly(eq)"
                              dense
                              outlined
                            />
                          </v-col>

                          <v-col cols="12" md="2">
                            <v-text-field
                              v-model="eq.data_devolucao"
                              type="date"
                              label="Data devolução"
                              dense
                              outlined
                              :disabled="!editMode && !viewMode"
                            />
                          </v-col>

                          <v-col
                            cols="12"
                            md="1"
                            class="d-flex align-center justify-center"
                          >
                            <v-tooltip
                              bottom
                              v-if="!eq.original_data_devolucao && !!eq.data_devolucao"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  icon
                                  class="error"
                                  v-bind="attrs"
                                  v-on="on"
                                  :disabled="savingExit"
                                  @click="registerEquipmentExit(eq, i)"
                                >
                                  <v-icon color="white">mdi-exit-run</v-icon>
                                </v-btn>
                              </template>
                              <span>Registar devolução</span>
                            </v-tooltip>
                          </v-col>

                          <v-col
                            cols="12"
                            md="auto"
                            class="d-flex align-center justify-center"
                            v-if="!editMode && !viewMode"
                          >
                            <v-btn
                              icon
                              class="error"
                              :disabled="isEquipmentReadOnly(eq) || fields.equipments.length === 1"
                              @click="removeEquipmentLine(i)"
                            >
                              <v-icon color="white">mdi-delete</v-icon>
                            </v-btn>
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </v-card>

                    <v-btn
                      icon
                      style="margin: auto; display: block;"
                      class="primary"
                      @click="addEquipmentLine"
                      v-if="!editMode"
                    >
                      <v-icon color="white">mdi-plus</v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
              </v-tab-item>

              <v-tab-item v-if="!editMode">
                <v-row class="mt-3">
                  <v-col cols="12">
                    <div class="text-caption mb-2">
                      {{
                        viewMode
                          ? "Assinatura registada:"
                          : "Assine no campo abaixo (tablet ou rato)."
                      }}
                    </div>

                    <div v-if="viewMode">
                      <v-img
                        v-if="fields.assinatura"
                        :src="fields.assinatura"
                        max-height="280"
                        contain
                      >
                        <template v-slot:placeholder>
                          <v-row
                            class="fill-height ma-0"
                            align="center"
                            justify="center"
                          >
                            <v-progress-circular indeterminate />
                          </v-row>
                        </template>
                      </v-img>

                      <div v-else class="text-caption grey--text">
                        Sem assinatura registada.
                      </div>
                    </div>

                    <SignaturePad v-else v-model="fields.assinatura" ref="sig" />
                  </v-col>
                </v-row>
              </v-tab-item>
            </v-tabs-items>
          </v-card-text>
        </div>

        <v-card-actions class="eva-dialog-actions">
          <v-row
            class="px-3 pb-2"
            align="center"
            justify="center"
            style="width:100%"
          >
            <v-col cols="12" class="d-flex justify-space-between">
              <v-btn text @click="onBackOrClose">
                {{ step === 0 ? "Fechar" : "Voltar" }}
              </v-btn>

              <v-btn
                v-if="!viewMode"
                rounded
                class="success"
                :disabled="step === 0 ? !canGoStep2 : !canSubmit"
                @click="onNextOrSubmit"
              >
                {{ editMode ? "Gravar" : step === 0 ? "Seguinte" : "Gravar" }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <SuccessSnackbar
      message="Registo de EPI criado com sucesso"
      v-model="success"
    />

    <SuccessSnackbar
      message="Sucesso ao registar devolução"
      v-model="successDevolut"
    />
  </div>
</template>

<script>
/*
  ODC-508 - Erbi Silva - 2026-02-06
  Adicionei a janela das Epis para o utilizador, onde é possível ver os epis que lhe foram entregues, e registar a devolução dos mesmos. Também adicionei um botão para criar um novo registo de epi, que abre o formulário de criação do epis.vue (reaproveitando o mesmo formulário para criar e editar).

  ODC-XXX - Categorias por linha
  Foi adicionada a coluna "Categoria" por linha. Cada linha pode escolher uma categoria diferente.
  Se o EPI tiver risks_id, esses riscos ficam pré-selecionados automaticamente quando o equipamento é escolhido.
*/
import EPIS from "@/api/EPIS.js";
import dayjs from "dayjs";
import User from "@/api/User.js";
import Obra from "@/api/Obra.js";
import SignaturePad from "@/components/UI/SignaturePad.vue";
import IconView from "@/components/UI/IconView.vue";
import SuccessSnackbar from "@/components/UI/Snackbars/SuccessSnackbar";

const NO_CATEGORY_VALUE = "__NO_CATEGORY__";

export default {
  name: "EPIS",
  components: { SignaturePad, IconView, SuccessSnackbar },
  props: {
    obras: { type: Array, default: () => [] },
    users_list: { type: Array, default: () => [] },
    is_management: { type: Boolean, default: false },
  },
  watch: {
    "fields.user_id": {
      immediate: false,
      async handler(userId) {
        if (!this.is_management) return;

        //this.fields.obra = null;
        this.obras_user = [];

        if (!userId) return;

        try {
          this.loadingObras = true;
          //const resp = await User.getUserObras(userId);
          const resp = await Obra.all({tipo: 'O'});
          this.obras_user = resp?.data || [];
        } catch (e) {
          console.error("Erro ao carregar obras do utilizador:", e);
        } finally {
          this.loadingObras = false;
        }
      },
    },
  },
  data: () => ({
    NO_CATEGORY_VALUE,
    editingEquipmentIndex: null,
    savingEquipmentExit: false,
    success: false,
    epis: [],
    risks: [],
    loading: false,
    menu1: false,
    menu2: false,

    editMode: false,
    viewMode: false,
    step: 0,

    editingIndex: null,
    successDevolut: false,
    savingExit: false,

    fields: {
      user_id: null,
      data_entrega: null,
      obra: null,
      sharepoint: null,
      assinatura: null,
      id: null,
      equipments: [],
    },
    obras_user: [],
    loadingObras: false,
    dialog: false,
    lines: [],
  }),
  mounted() {
    this.fillBaseData();
  },
  computed: {
    maxDate() {
      return new Date().toISOString().split("T")[0];
    },

    categoryOptions() {
      const seen = new Set();
      const options = [
        {
          label: "-",
          value: NO_CATEGORY_VALUE,
        },
      ];

      (this.epis || []).forEach((epi) => {
        const categoryName = epi?.category?.category;
        if (!categoryName) return;
        if (seen.has(categoryName)) return;

        seen.add(categoryName);
        options.push({
          label: categoryName,
          value: categoryName,
        });
      });

      return options;
    },

    canGoStep2() {
      if (this.editMode) return true;
      if (this.viewMode) return true;

      const baseOk = !!(this.fields.data_entrega && this.fields.obra);
      if (!baseOk) return false;

      if (this.is_management && !this.fields.user_id) return false;

      const eqs = this.fields.equipments || [];
      if (!eqs.length) return false;

      const allValid = eqs.every(
        (e) => !!e.epi_id && Array.isArray(e.riscos) && e.riscos.length >= 1
      );

      return allValid;
    },

    canSubmit() {
      if (this.editMode) {
        return (this.fields.equipments || []).some(eq => !!eq.data_devolucao);
      }
      return this.canGoStep2 && !!this.fields.assinatura;
    },
  },
  methods: {
    createEquipmentLine(overrides = {}) {
      return {
        _key: `${Date.now()}_${Math.random().toString(36).slice(2)}`,
        id: null,
        category_key: NO_CATEGORY_VALUE,
        epi_id: null,
        riscos: [],
        data_devolucao: null,
        original_data_devolucao: null,
        ...overrides,
      };
    },

    getCategoryKeyFromEpi(epi) {
      return epi?.category?.category || NO_CATEGORY_VALUE;
    },

    getEpiById(epiId) {
      return (this.epis || []).find((e) => e.id === epiId) || null;
    },

    getFilteredEpis(eq) {
      const categoryKey = eq?.category_key ?? NO_CATEGORY_VALUE;

      return (this.epis || []).filter((epi) => {
        const epiCategoryKey = this.getCategoryKeyFromEpi(epi);
        return epiCategoryKey === categoryKey;
      });
    },

    onCategoryChange(eq) {
      if (!eq) return;

      const selectedEpi = this.getEpiById(eq.epi_id);
      if (!selectedEpi) {
        eq.riscos = Array.isArray(eq.riscos) ? eq.riscos : [];
        return;
      }

      const selectedCategoryKey = eq.category_key ?? NO_CATEGORY_VALUE;
      const epiCategoryKey = this.getCategoryKeyFromEpi(selectedEpi);

      if (selectedCategoryKey !== epiCategoryKey) {
        eq.epi_id = null;
        eq.riscos = [];
      }
    },

    onEquipmentChange(eq) {
      if (!eq) return;

      const selectedEpi = this.getEpiById(eq.epi_id);

      if (!selectedEpi) {
        eq.riscos = [];
        return;
      }

      eq.category_key = this.getCategoryKeyFromEpi(selectedEpi);

      const epiRisks = Array.isArray(selectedEpi.risks_id)
        ? selectedEpi.risks_id.filter(Boolean)
        : [];

      const existingRisks = Array.isArray(eq.riscos) ? eq.riscos : [];

      eq.riscos = [...new Set([...existingRisks, ...epiRisks])];
    },

    isEquipmentReadOnly(eq) {
      if (this.viewMode) return true;                 // modo ver: tudo bloqueado
      if (this.editMode) return !!eq.original_data_devolucao; // se já tinha data → bloqueado
      return false;                                   // criação: editável
    },

    startEquipmentExit(index) {
      this.editingEquipmentIndex = index;

      const eq = this.fields.equipments[index];
      if (eq && !eq.data_devolucao) {
        eq.data_devolucao = new Date().toISOString().slice(0, 10);
      }
    },

    async saveEquipmentExit(eq, index) {
      if (!eq?.id) {
        console.error(
          "Equipamento sem id. Garante que o backend devolve equipments[].id."
        );
        return;
      }
      if (!eq.data_devolucao) return;

      try {
        this.savingEquipmentExit = true;

        await EPIS.registerEquipmentExit({
          equipment_id: eq.id,
          data_devolucao: eq.data_devolucao,
        });

        this.editingEquipmentIndex = null;
        this.successDevolut = true
      } catch (e) {
        console.error("Erro ao registar devolução do equipamento:", e);
      } finally {
        this.savingEquipmentExit = false;
      }
    },

    async registerEquipmentExit(eq, index) {
      if (!eq?.id) return;

      try {
        this.savingExit = true;

        await EPIS.registerExit({
          id: eq.id,
          data_devolucao: eq.data_devolucao,
        });

        this.$set(this.fields.equipments, index, {
          ...eq,
          original_data_devolucao: eq.data_devolucao
        });

        this.successDevolut = true;

      } catch (e) {
        console.error("Erro ao registar devolução:", e);
      } finally {
        this.savingExit = false;
      }
    },

    addEquipmentLine() {
      if (!this.fields.equipments) this.fields.equipments = [];
      this.fields.equipments.push(this.createEquipmentLine());
    },

    removeEquipmentLine(index) {
      if (this.fields.equipments.length <= 1) return;
      this.fields.equipments.splice(index, 1);
    },

    openNativeDatePicker() {
      const input = this.$refs.dateInput.$el.querySelector("input");
      if (input && input.showPicker) {
        input.showPicker();
      }
    },

    openCreateFromManagement() {
      this.resetForm();
      this.viewMode = false;
      this.editMode = false;
      this.dialog = true;
      this.step = 0;
      this.obras_user = [];
      this.loadingObras = false;
    },

    formatDate(d) {
      return d ? dayjs(d).format("DD/MM/YYYY") : "—";
    },

    onBackOrClose() {
      if (this.step === 0) {
        this.dialog = false;
        return;
      }
      this.step = 0;
    },

    async onNextOrSubmit() {
      if (this.editMode) {
        await this.saveExit();
        return;
      }

      if (this.step === 0) {
        this.step = 1;
        this.$nextTick(() => {
          if (this.$refs.sig && this.$refs.sig.resizeCanvas) {
            this.$refs.sig.resizeCanvas();
          }
        });
        return;
      }

      await this.addEpiWithSignature();
    },

    openCreate() {
      this.resetForm();
      this.viewMode = false;
      this.editMode = false;
      this.dialog = true;
    },

    async openEPI(item) {
      try {
        this.loading = true;
        this.resetForm();

        this.viewMode = true;
        this.editMode = false;
        this.step = 0;

        const resp = await EPIS.getEpi(item.id);
        const row = resp?.data;
        if (!row) return;

        const userId = row.user_id || this.$route.params.id || null;

        if (this.is_management && userId) {
          this.fields.user_id = userId;
          const obrasResp = await Obra.all({tipo: 'O'});
          this.obras_user = obrasResp?.data || [];
        }

        console.log('row raw', JSON.parse(JSON.stringify(row)));

        this.fields = {
          user_id: row.Codigo ?? this.$route.params.id,
          data_entrega: row.data_entrega ? row.data_entrega.slice(0, 10) : null,
          obra: row.obra_id ?? null,
          sharepoint: row.sharepoint ?? null,
          assinatura: row.assinatura_url ?? null,
          id: row.id ?? null,
          equipments: (row.equipments ?? []).map((e) => {
            const epi = this.getEpiById(e.epi_id);
            const originalDate = e.data_devolucao ? e.data_devolucao.slice(0, 10) : null;

            return this.createEquipmentLine({
              id: e.id,
              _key: e.id,
              category_key: this.getCategoryKeyFromEpi(epi),
              epi_id: e.epi_id,
              qty: e.qty || 1,
              data_devolucao: originalDate,
              original_data_devolucao: originalDate,
              riscos: (e.riscos ?? []).map((r) => r.id),
              qty: e.qty || 1,
            });
          }),
        };

        console.log('fields final', JSON.parse(JSON.stringify(this.fields)));

        if (!this.fields.equipments.length) {
          this.fields.equipments = [this.createEquipmentLine()];
        }

        this.dialog = true;
        this.step = 0;
      } catch (e) {
        console.error("Erro ao abrir EPI:", e);
      } finally {
        this.loading = false;
      }
    },

    async addEpiWithSignature() {
      const sig = this.$refs.sig ? this.$refs.sig.getDataUrl() : null;
      this.fields.assinatura = sig;

      const userId = this.is_management
        ? this.fields.user_id
        : this.$route.params.id;

      const payload = {
        id: `${Date.now()}_${Math.random().toString(36).slice(2)}`,
        data_entrega: this.fields.data_entrega,
        obra_id: this.fields.obra,
        sharepoint: this.fields.sharepoint || null,
        user_id: userId,
        assinatura: this.fields.assinatura,

        equipments: (this.fields.equipments || []).map((e) => ({
          epi_id: e.epi_id,
          data_devolucao: e.data_devolucao || null,
          riscos: e.riscos || [],
          qty: e.qty || 1,
        })),
      };

      await EPIS.registerEPIUser(payload);

      this.resetForm();
      this.dialog = false;
      this.$emit("load-table");
      this.success = true;
      this.loadRisks();
    },

    async fillBaseData() {
      this.loading = true;
      const [epis, risks] = await Promise.all([EPIS.all(), EPIS.getRisks()]);
      this.epis = epis.data || [];
      this.risks = risks.data || [];
      await this.loadRisks();
      this.loading = false;
    },

    loadRisks() {
      this.loading = true;
      EPIS.getUserEpis(this.$route.params.id).then((resp) => {
        const data_lines = resp.data || [];
        this.lines = data_lines.map((element) => {
          const epiSel = this.epis.find((e) => e.id === element.epi_id) || {};
          const riscoSel = this.risks.find((r) => r.id === element.risco_id) || {};
          const obraSel = this.obras.find((o) => o.Id === element.obra_id) || {};

          return {
            id: element.id,
            data_entrega: element.data_entrega,
            data_devolucao: element.data_devolucao,
            epi_id: element.epi_id,
            epi_desc: epiSel.description || "",
            risco_id: element.risco_id,
            risco_ref: riscoSel.reference || "",
            risco_desc: riscoSel.description || "",
            obra_id: element.obra_id,
            obra_codigo: obraSel.Codigo || "",
            obra_descricao: obraSel.Descricao || "",
            sharepoint: element.sharepoint || null,
            user_id: this.$route.params.id,
          };
        });
        this.loading = false;
      });
    },
    async openExit(item, index) {
      try {
        this.loading = true;
        this.resetForm();

        this.editMode = true;
        this.viewMode = false;
        this.editingIndex = index;
        this.step = 0;

        const resp = await EPIS.getEpi(item.id);
        const row = resp?.data;
        if (!row) return;

        const userId = row.user_id || this.$route.params.id || null;

        if (this.is_management && userId) {
          this.fields.user_id = userId;
          const obrasResp = await User.getUserObras(userId);
          this.obras_user = obrasResp?.data || [];
        }

        this.fields = {
          user_id: row.user_id || this.$route.params.id,
          data_entrega: row.data_entrega ? row.data_entrega.slice(0, 10) : null,
          obra: row.obra_id || null,
          sharepoint: row.sharepoint || null,
          assinatura: null,
          id: row.id || item.id || null,
          data_devolucao: row.data_devolucao
            ? row.data_devolucao.slice(0, 10)
            : null,

          equipments: (row.equipments || []).map((e) => {
            const epi = this.getEpiById(e.epi_id);

            const originalDate = e.data_devolucao ? e.data_devolucao.slice(0, 10) : null;

            return this.createEquipmentLine({
              id: e.id,
              _key: e.id,
              category_key: this.getCategoryKeyFromEpi(epi),
              epi_id: e.epi_id,
              data_devolucao: originalDate,
              original_data_devolucao: originalDate,
              riscos: (e.riscos || []).map((r) => r.id),
            });
          }),
        };

        if (!this.fields.equipments.length) {
          this.fields.equipments = [this.createEquipmentLine()];
        }

        this.dialog = true;
      } catch (e) {
        console.error("Erro ao abrir devolução do EPI:", e);
      } finally {
        this.loading = false;
      }
    },
    async saveExit() {
      const equipmentsToExit = (this.fields.equipments || []).filter(
        eq => !!eq.id && !!eq.data_devolucao
      );

      if (!equipmentsToExit.length) return;

      try {
        this.savingExit = true;

        for (const eq of equipmentsToExit) {
          await EPIS.registerExit({
            id: eq.id,
            data_devolucao: eq.data_devolucao,
          });
        }

        await this.loadRisks();

        this.resetForm();
        this.editMode = false;
        this.viewMode = false;
        this.editingIndex = null;
        this.dialog = false;
      } catch (e) {
        console.error("Erro ao gravar devoluções:", e);
      } finally {
        this.savingExit = false;
      }
    },

    resetForm() {
      this.step = 0;
      this.editMode = false;
      this.viewMode = false;
      this.editingIndex = null;

      this.fields = {
        data_entrega: null,
        obra: null,
        sharepoint: null,
        assinatura: null,
        id: null,
        user_id: null,
        equipments: [this.createEquipmentLine()],
      };
    },
  },
};
</script>

<style scoped>
.eva-dialog-card {
  display: flex;
  flex-direction: column;
}

.eva-dialog-card--fullscreen {
  height: 100vh;
  border-radius: 0 !important;
}

.eva-dialog-toolbar,
.eva-dialog-tabs,
.eva-dialog-actions {
  flex: 0 0 auto;
}

.eva-dialog-body {
  flex: 1 1 auto;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

@media (max-width: 960px) {
  :deep(.eva-tabs .v-tab) {
    font-size: 0.3rem !important; /* ~ metade */
    min-width: 0 !important;
    padding: 0 8px !important;
  }

  :deep(.eva-tabs .v-tabs-bar) {
    height: 36px !important;
  }
}
</style>
